<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 200 200" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <circle r="100" cy="100" cx="100" fill="#92baff" />
      <path d="M74.3 88.6h51.5c2.7-.6 4.7-3 4.7-5.9V61c0-1.6-.6-3.1-1.7-4.2s-2.7-1.7-4.2-1.7h-49c-3.3 0-6 2.7-6 6v21.7c-.1 2.8 2 5.2 4.7 5.8z" fill="#fff" />
      <path d="M140.5 103.1v15H135v-12.2h-32.2v12.2h-5.5v-12.2H65v12.2h-5.5v-15c0-1.5 1.2-2.8 2.8-2.8h35V88.7H75.5c-.4 0-.8 0-1.2-.1h51.5c-.4.1-.8.1-1.2.1h-21.7v11.7h35c1.4 0 2.6 1.2 2.6 2.7z" fill="#e5eeff" />
      <path d="M150.4 119.8c-1-1-2.4-1.6-3.9-1.6h-17.3c-1.5 0-2.8.6-3.9 1.6-1 1-1.6 2.4-1.6 3.9v15.9c0 3 2.5 5.5 5.5 5.5h17.3c3 0 5.5-2.5 5.5-5.5v-15.9c0-1.5-.6-2.9-1.6-3.9z" fill="#fff" />
      <path d="M108.6 118.1H91.4c-1.5 0-2.8.6-3.9 1.6-1 1-1.6 2.4-1.6 3.9v15.9c0 3 2.5 5.5 5.5 5.5h17.3c1.5 0 2.8-.6 3.9-1.6 1-1 1.6-2.4 1.6-3.9v-15.9c0-1.5-.6-2.8-1.6-3.9-1.1-1-2.5-1.6-4-1.6z" fill="#e5eeff" />
      <path d="M70.7 118.1H53.5c-1.4 0-2.8.6-3.9 1.6-1 1-1.6 2.4-1.6 3.9v15.9c0 3 2.5 5.5 5.5 5.5h17.3c1.5 0 2.8-.6 3.9-1.6 1-1 1.6-2.4 1.6-3.9v-15.9c0-1.5-.6-2.8-1.6-3.9-1.1-1-2.5-1.6-4-1.6z" fill="#fff" />
    </g>
  </svg>
</template>
<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
